import { JSX } from "react";

enum RootType {
  Tags = "Tags",
  ServiceAreas = "ServiceAreas"
}

const rootsToRender = ["Specialties"];

/** Renders the icon for a given root of a namespace path. */
function RootIcon(props: { root: string }): JSX.Element {
  let icon: string;
  switch (props.root as RootType) {
    case RootType.ServiceAreas:
      icon = "fa-map-pin";
      break;
    case RootType.Tags:
      icon = "fa-tag";
      break;
    default:
      icon = "fa-filter";
      break;
  }

  let rootString = "";
  if (rootsToRender.includes(props.root)) {
    rootString = props.root;
  }

  return (
    <>
      <i className={`fa ${icon} mr10`} /> <span>{rootString}</span>
    </>
  );
}

export { RootIcon };
